const productCategory = [
    { id: 1, label: "Full Helmet", value: "Full Helmet" },
    { id: 2, label: "Half Helmet", value: "Half Helmet" },
    { id: 3, label: "Dirt Helmet", value: "Dirt Helmet" },
    { id: 4, label: "Motor Oil", value: "Motor Oil" },
    { id: 5, label: "Gloves", value: "Gloves" },
    { id: 6, label: "Tyres", value: "Tyres" },
    { id: 7, label: "Raincoat", value: "Raincoat" },
    { id: 8, label: "Goggles", value: "Goggles" },
]


export default productCategory